import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 13 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_5218_5567)" }, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M12.25 0.5H7.25L1.543 6.207C1.35553 6.39453 1.25021 6.64884 1.25021 6.914C1.25021 7.17916 1.35553 7.43347 1.543 7.621L5.129 11.207C5.31653 11.3945 5.57084 11.4998 5.836 11.4998C6.10116 11.4998 6.35547 11.3945 6.543 11.207L12.25 5.5V0.5Z",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_5218_5567" }, [
    /*#__PURE__*/_createElementVNode("rect", {
      width: "12",
      height: "12",
      fill: "white",
      transform: "matrix(-1 0 0 1 12.75 0)"
    })
  ])
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }